var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcAddUser = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "34px",
  height: "34px",
  viewBox: "0 0 34 34",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  ref: ref,
  "aria-labelledby": titleId
}, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, "ic_add_user") : title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "ic_add_user",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  x: 0,
  y: 0,
  width: 34,
  height: 34
}), /*#__PURE__*/React.createElement("g", {
  id: "filter-icon"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3.4,0 L34,0 L34,34 L3.4,34 C1.52223185,34 -1.10230735e-15,32.4777681 -1.33226763e-15,30.6 L-4.4408921e-16,3.4 C-6.74049485e-16,1.52223185 1.52223185,-9.87327216e-16 3.4,-1.33226763e-15 Z",
  id: "Rectangle-2"
})), /*#__PURE__*/React.createElement("g", {
  id: "icon",
  transform: "translate(5.000000, 5.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-4-Copy",
  x: 0,
  y: 0,
  width: 24,
  height: 24
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-4",
  stroke: "#FFFFFF",
  cx: 12,
  cy: 12,
  r: 8.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.5,11.5 L16,11.5 L16,12.5 L12.5,12.5 L12.5,16 L11.5,16 L11.5,12.5 L8,12.5 L8,11.5 L11.5,11.5 L11.5,8 L12.5,8 L12.5,11.5 Z",
  id: "Combined-Shape",
  fill: "#FFFFFF"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcAddUser);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "matrices-static/media/ic_add_user.26a153aac1b5ce1c7ab5aeb2f63f62b4.svg";